import React from "react";

function NavBar() {
  return (
    <>
      <section>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <div className="container">
              <h1 className="text-success text-center">
                TV-Maze Search App
              </h1>
            </div>
          </div>
        </nav>
      </section>
    </>
  );
}

export default NavBar;
